var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"title":"Upload Asset Type Image"}},[_c('image-manager',{ref:"assetTypeImageManager",on:{"upload":_vm.uploadImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }